<div class="mc-task-profile-comments-body">
  <mc-comment-box *ngIf="canEditAllTasks" class="mc-task-profile-comment-box" [comment]="newComment" [checkIsDirty]="true" (isDirtyChanged)="onCommentGroupDirtyChanged()">
  </mc-comment-box>
  <div class="mc-task-profile-comments-new-comment-container">
    <mc-task-comment-group *ngFor="let commentGroup of commentGroups" [commentGroup]="commentGroup" [licenseId]="licenseId" [showDelete]="showDelete" [canEditAllTasks]="canEditAllTasks" [checkIsDirty]="true" (isDirtyChanged)="onCommentGroupDirtyChanged()">
    </mc-task-comment-group>
  </div>
</div>
